import { timestamp } from "drizzle-orm/pg-core";

export const timestamps = {
    updated_at: timestamp().defaultNow(),
    created_at: timestamp().defaultNow().notNull(),
    deleted_at: timestamp(),
}

export function generateUniqueString(length: number = 12): string {
  const characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let uniqueString = "";

  for (let i = 0; i < length; i++) {
    const randomIndex = Math.floor(Math.random() * characters.length);
    uniqueString += characters[randomIndex];
  }

  return uniqueString;
}
